module.exports = __webpack_public_path__ + "6b956c87163562e82985cf94ecf49c12.svg";